import { useState } from "react";
import { Box, TextField, Grid, Paper, MenuItem, Select } from "@mui/material";
import axios from "../../config/axios";
import { resolveErrMsg, getUserData, hasAccess } from "../../utils/utilities";
import FormLabel from "../../components/FormLabel";
import CommonDialog from "../../components/CommonDialog";

const style = {
  position: "absolute",
  top: "30%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  bgcolor: "background.paper",
  outline: "none",
  p: 4,
};

const LinkProfileModal = (props) => {
  // const [userData, setUserData] = useState({ isSuperAdmin: props.createSuperAdmin || false });
  const [userData, setUserData] = useState({
    role: props.createSuperAdmin ? "SuperAdmin" : "" || false,
    company_id:
      getUserData().role == "Company" || getUserData().role == "CompanyAdmin"
        ? getUserData().company_id
        : null,
  });
  const [btnLoader, setBtnLoader] = useState(false);
  const [validations, setValidations] = useState({});

  // other functions
  const handleCloseModal = () => {
    props.setOpen(false);
  };

  const handleChange = (field, value) => {
    setUserData((prevState) => ({
      ...prevState,
      [`${field}`]: value,
    }));
  };

  // API Services
  const handleAddUser = () => {
    setBtnLoader(true);
    setValidations({});

    let url = props.createSuperAdmin
      ? "super-admin/create"
      : hasAccess()
      ? "admin/create"
      : "user/create";

    let body =
      props.createSuperAdmin || hasAccess()
        ? { ...userData }
        : { ...userData, adminId: getUserData().id };

    axios
      .post(url, body)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.status) {
            props.setAlert({
              variant: "success",
              msg: res.data.message,
              status: true,
            });
            handleCloseModal();
          } else {
            if (res.data.type === "validation") {
              const tempVal = {};
              res.data.error?.forEach((err) => {
                tempVal[err.field] = err.message;
                // tempVal[err.field] = resolveErrMsg(err.type);
              });
              setValidations(tempVal);
            }
            if (res.data.type === "error") {
              props.setAlert({
                variant: "error",
                msg: res.data.error?.message,
                status: true,
              });
            }
          }
        }
        setBtnLoader(false);
        props.getList();
      })
      .catch((err) => console.log(err));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleAddUser();
    }
  };

  return (
    <CommonDialog
      open={props.open}
      title={props.title || "Link Profile"}
      submitLabel="Add"
      onSubmit={handleAddUser}
      onClose={handleCloseModal}
    >
      <Paper style={{ ...props.style, width: "100%" }} elevation={0}>
        <Box>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <FormLabel title="Name" />
              <TextField
                placeholder="Name"
                size="small"
                error={validations.name}
                helperText={validations.name || ""}
                value={userData.name || ""}
                onChange={(e) => handleChange("name", e.target.value)}
                fullWidth
                onKeyDown={handleKeyDown}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <FormLabel title="Email" />
              <TextField
                placeholder="Email"
                size="small"
                error={validations.email}
                helperText={validations.email || ""}
                value={userData.email || ""}
                onChange={(e) => handleChange("email", e.target.value)}
                onKeyDown={handleKeyDown}
                fullWidth
              />
            </Grid>
            {!props?.createSuperAdmin && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FormLabel title="Role" />
                <Select
                  placeholder="Role"
                  size="small"
                  value={userData.role || false}
                  onChange={(e) => handleChange("role", e.target.value)}
                  fullWidth
                >
                  <MenuItem value={"Admin"}> Employee </MenuItem>
                  <MenuItem value={"CompanyAdmin"}>Company Admin</MenuItem>
                </Select>
              </Grid>
            )}

            {getUserData().role == "SuperAdmin" &&
              props?.companyList?.length > 0 && (
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <FormLabel title="Company" />
                  <Select
                    placeholder="Company"
                    size="small"
                    value={userData.company_id || false}
                    onChange={(e) => handleChange("company_id", e.target.value)}
                    fullWidth
                  >
                    <MenuItem disabled value="">
                      <em>Select Company</em>
                    </MenuItem>
                    {props?.companyList?.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
              )}
          </Grid>
        </Box>
      </Paper>
    </CommonDialog>
  );
};

export default LinkProfileModal;
